// extracted by mini-css-extract-plugin
export default {"illustrationContainer":"src-hellospa-components-modal-throttle-usage-modal-throttle-usage-module__illustrationContainer--rLklf"};